import React from "react";
import { NavLink } from "react-router-dom";

import { gqlType } from "@hifieng/common";
import { Heading, Meta, Text } from "../../Type";
import styles from "./index.module.scss";
import DateTime from "../../DateTime";
import { MILLISECONDS_IN_SECONDS } from "../../../helpers/constants";
import { ArrowPoint } from "../../Icons";
import { kpMpRatio } from "../../AnalysisCharts/BaseChart";
import { useAuth } from "../../../contexts/AuthProvider";

type PropsType = {
  trainRun: gqlType.TrainRun;
  url: string;
};

const Completed = ({ trainRun, url }: PropsType) => {
  const { permissions } = useAuth();
  return (
    <NavLink to={url} className={styles.CompletedCard}>
      <div className={styles.Header}>
        <div className={styles.TitleGroup}>
          <Heading className={styles.Type} size="h7">
            {trainRun.pipeline.name} - Run {trainRun.runId}
          </Heading>
          <Heading className={styles.TypeDark} size="h7">
            {trainRun.type ? trainRun.type.toLocaleLowerCase() : "Unknown"}{" "}
            train
          </Heading>
          <div className={styles.InfoGroupWrapper}>
            <div className={styles.InfoGroup}>
              <Meta dark>START</Meta>
              <Text className={styles.Type}>
                <DateTime
                  timestamp={trainRun.startTime * MILLISECONDS_IN_SECONDS}
                  length="long"
                />
                <br />
                {(permissions.user.imperial ? true : false) ||
                trainRun.pipelineId === "enbridge_line_3" ||
                trainRun.pipelineId === "enbridge_line_4"
                  ? `MP ${trainRun.startPost * kpMpRatio}`
                  : `KP ${trainRun.startPost}`}
              </Text>
            </div>
            <div className={styles.IconContainer}>
              <ArrowPoint />
            </div>
            {trainRun.endPost && trainRun.endTime && (
              <div className={styles.InfoGroup}>
                <Meta dark>END</Meta>
                <Text className={styles.Type}>
                  <DateTime
                    timestamp={trainRun.endTime * MILLISECONDS_IN_SECONDS}
                    length="long"
                  />
                  <br />
                  {(permissions.user.imperial ? true : false) ||
                  trainRun.pipelineId === "enbridge_line_3" ||
                  trainRun.pipelineId === "enbridge_line_4"
                    ? `MP ${trainRun.endPost * kpMpRatio}`
                    : `KP ${trainRun.endPost}`}
                </Text>
              </div>
            )}
          </div>
        </div>
        <div className={styles.Updates}>
          <Text className={styles.Type}>
            {trainRun.numberOfUpdates} Updates -{" "}
            {trainRun.numberOfCriticalEvents} Critical Events
          </Text>
          <Text
            className={styles.Type}
          >{`${trainRun.auditLogs.length} Notes`}</Text>
        </div>
      </div>
    </NavLink>
  );
};

export default Completed;
